module.exports = __webpack_public_path__ + "static/media/woman_doctor.b282dbbb.jpg";